import { Navigate } from "react-router-dom";
import { useAppMode } from "@/hooks/useAppMode";
import Index from "@/pages/Index";

const RootRoute = () => {
  const { isAppMode, isLoading } = useAppMode();

  if (isLoading) return null;
  if (isAppMode) return <Navigate to="/app" replace />;
  return <Index />;
};

export default RootRoute;
